const state = {
    mode: null,
    confirmed: false
}

const getters = {
    getMode(state) {
        return state.mode
    },
    getConfirmed(state) {
        return state.confirmed
    },
}

const actions = {
    setMode({commit}, mode) {
        commit('setMode', mode)
    },
    setConfirmed({commit}, confirmed) {
        commit('setConfirmed', confirmed)
    },
}

const mutations = {
    setMode(state, mode){
        state.mode = mode
    },
    setConfirmed(state, confirmed){
        state.confirmed = confirmed
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}